import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 5v8h8","key":"svg-0"}],["path",{"d":"M7 9v8h8","key":"svg-1"}]]

const IconChevronsDownLeft = createReactComponent('outline', 'chevrons-down-left', 'ChevronsDownLeft', __iconNode);

export default IconChevronsDownLeft;